var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.18981 10.2054L9.05221 5.1786L10.9276 7.11479L6.06303 12.145L3.31188 13.0513L4.18981 10.2054ZM10.631 3.54416C10.8823 3.28585 11.2155 3.14298 11.5687 3.14298C11.9218 3.14298 12.254 3.28471 12.5053 3.54302C13.0234 4.07793 13.0234 4.94887 12.5064 5.48378L11.7104 6.30671L9.83385 4.36938L10.631 3.54416Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.e6a400a0569497e550f1c7fde11cbffa.svg";
export { ForwardRef as ReactComponent };